import React, { useEffect, useMemo, useState } from 'react';
import { DialogUI, FormButtonPanelUI } from '../../Interface';
import Yup from '../../../utils/yup';
import { Form, Formik } from 'formik';
import ItemAddDialogFields from './ItemAddDialogFields';
import useUsers from '../../../context/UsersContext';
import addNotification from '../../../utils/addNotification';
import { NotificationType } from '../../../config';
import { cleanValues, generateAutocompleteItems } from '../../../utils/helper';
import itemService from '../../../service/item.service';
import masterDataService from '../../../service/masterData.service';
import { ItemKind } from '../../../config/item';
import useConfig from '../../../context/ConfigContext';
import { isCustomItemCodeGenerationEnabled } from '../itemCodeGeneration';

const ItemAddDialog = ({ open, handleClose, setRefetch, setValues }) => {
  const { getUser, user } = useUsers();
  const { config, getConfig } = useConfig();
  const def = {
    itemCode: '',
    itemName: '',
    itemGroupId: null,
    type: '',
    quantityUnitId: null,
    active: true,
    kind: ItemKind.EQUIPMENT,
    autoGenerateItemCode: null,
  };
  const [autoCompleteOptions, setAutoCompleteOptions] = useState({
    itemGroup: [],
    quantityUnit: [],
  });
  const [autoCompleteData, setAutoCompleteData] = useState({});

  useEffect(() => {
    if (!Object.keys(user).length) getUser();
    if (!Object.keys(config).length) getConfig();
    initDefaultValues();
  }, []);

  const initDefaultValues = () => {
    const promiseArray = [];

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .quantityUnitToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .itemGroupToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    Promise.all(promiseArray)
      .then((resp) => {
        const aData = {
          quantityUnit: resp[0],
          itemGroup: resp[1],
        };
        setAutoCompleteData(aData);

        const acOptions = {
          quantityUnit: generateAutocompleteItems(aData.quantityUnit, 'name', 'id'),
          itemGroup: generateAutocompleteItems(aData.itemGroup, 'name', 'id'),
        };
        setAutoCompleteOptions(acOptions);
      })
      .finally(() => {
        //hideLoader();
      });
  };

  const validationSchema = Yup.object().shape({
    itemCode: Yup.string().nullable(),
    itemName: Yup.string().required(),
    quantityUnitId: Yup.string().nullable(),
    itemGroupId: Yup.string().required(),
    type: Yup.string().nullable(),
    stockItemType: Yup.string().nullable(),
    inPurchase: Yup.boolean(),
    inSales: Yup.boolean(),
    weight: Yup.number().nullable(),
    landedCost: Yup.boolean(),
    active: Yup.boolean(),
    kind: Yup.string().oneOf(Object.values(ItemKind)).nullable(),
    autoGenerateItemCode: Yup.boolean().nullable(),
  });

  const handleInsertObject = async (values) => {
    if (!values.itemCode) {
      addNotification({
        content: 'Hiányzik a cikkszám!',
        type: NotificationType.WARNING,
      });
      return;
    }

    if (!values.quantityUnitId) {
      addNotification({
        content: 'Hiányzik a mennyiségi egység!',
        type: NotificationType.WARNING,
      });
      return;
    }

    const { autoGenerateItemCode, ...restValues } = values;

    const insertObject = {
      ...cleanValues(restValues),
      createdBy: user.userId,
      ...(isCustomItemCodeGenerationEnabled(config) ? { autoGenerate: autoGenerateItemCode ?? true } : {}),
    };

    const formData = new FormData();
    formData.append('data', JSON.stringify(insertObject));

    itemService
      .createItem(formData)
      .then((data) => {
        addNotification({
          content: 'Sikeres mentés!',
          type: NotificationType.SUCCESS,
        });

        handleClose();
        setRefetch(true);
        setValues((prev) => ({
          ...prev,
          itemCode: data.itemCode,
        }));
      })
      .finally(() => {
        //@TODO loader
      });
  };

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Cikk"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <Formik
        initialValues={def}
        validationSchema={validationSchema}
        validateOnChange={false}
        onSubmit={handleInsertObject}
        enableReinitialize
        //validateOnMount={false}
      >
        {({}) => (
          <Form>
            <ItemAddDialogFields autoCompleteOptions={autoCompleteOptions} autoCompleteData={autoCompleteData} />

            <FormButtonPanelUI
              onCancelClick={() => {
                handleClose();
              }}
            />
          </Form>
        )}
      </Formik>
    </DialogUI>
  );
};

export default ItemAddDialog;
